(function (app) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider
                .state("Home.Tools.MarketingTracker.Plans.MarketingPlan",
                    {
                        url: "/MarketingPlan/{marketingPlanId}",
                        component: "marketingplan",
                        PageTitle: "Marketing Tracker - Marketing Plan",
                        resolve: {
                            marketingPlanDocument: ["$stateParams", "marketingPlanApi", "marketingTrackerAgent",
                                function ($stateParams, marketingPlanApi, marketingTrackerAgent) {
                                    return marketingPlanApi
                                        .getMarketingPlanDocument(marketingTrackerAgent.AgentId,
                                            $stateParams.marketingPlanId).then(function (file) {
                                                return URL.createObjectURL(file);
                                            });
                                }]
                        }
                    });
        }
    ]);

    app.component("marketingplan",
        {
            templateUrl: "App/Tools/MarketingTracker/Plans/MarketingPlan/marketingplan-template.html",
            controller: marketingPlanController,
            bindings: {
                marketingPlanDocument: "<"
            }
        });

    marketingPlanController.$inject = ["$scope"];
    function marketingPlanController($scope) {
        var $ctrl = this;

        $scope.$on("$destroy",
            function () {
                if ($ctrl.marketingPlanDocument)
                    URL.revokeObjectURL($ctrl.marketingPlanDocument);
            });
    }

})(window.app);